import { type GetServerSidePropsContext } from 'next'
import { CMSPage } from '@/features/cms/components/CMS/CMSPage'
import { fetchCMSDataForSSR } from '@/features/cms/services/CMS/serverUtils'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { verifySlugExists } from '@shared/cms_slug_client'

// oxlint-disable-next-line eslint-js/no-restricted-syntax -- disable since we are still using createServerSidePropsHandler
export const getServerSideProps = (ssrContext: GetServerSidePropsContext) => {
  const { resolvedUrl } = ssrContext

  const slug = resolvedUrl
    .slice(1) // remove leading slash from path, as slugs in CMS do not have leading slashes
    .split('?')[0] // take part before query params
    ?.toLowerCase()

  if (!slug || !verifySlugExists(slug)) {
    return { notFound: true }
  }

  return createServerSidePropsHandler(RouteName.CMS_CATCHALL, fetchCMSDataForSSR)(ssrContext)
}

export default CMSPage
